#!/usr/bin/env node

import { Command } from 'commander';
import { loadEnv, generateTypes } from './index';
import fs from 'fs';
import path from 'path';

const program = new Command();

program
  .name('env-schema-checker')
  .description('A zero-config, type-safe, schema-driven .env validator')
  .version('0.1.1');

program
  .command('validate')
  .description('Validate environment variables against a schema')
  .option('-p, --path <path>', 'Path to .env file')
  .option('-s, --schema <path>', 'Path to schema file (JSON)')
  .action(async (options) => {
    try {
      const schemaPath = options.schema || '.env.schema.json';
      if (!fs.existsSync(schemaPath)) {
        console.error(`Schema file not found: ${schemaPath}`);
        process.exit(1);
      }

      const schema = JSON.parse(fs.readFileSync(schemaPath, 'utf-8'));
      const result = loadEnv({
        schema,
        path: options.path || '.env',
      });

      if (!result.success) {
        console.error('Environment validation failed:');
        result.errors?.forEach((err) => {
          console.error(`  ${err.key}: ${err.message} (received: ${err.value})`);
        });
        process.exit(1);
      }

      console.log('✅ Environment validation successful!');
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error('Error:', error.message);
      } else {
        console.error('An unknown error occurred');
      }
      process.exit(1);
    }
  });

program
  .command('gen-types')
  .description('Generate TypeScript type definitions from schema')
  .option('-s, --schema <path>', 'Path to schema file (JSON)')
  .option('-o, --output <path>', 'Output path for type definitions')
  .action(async (options) => {
    try {
      const schemaPath = options.schema || '.env.schema.json';
      if (!fs.existsSync(schemaPath)) {
        console.error(`Schema file not found: ${schemaPath}`);
        process.exit(1);
      }

      const schema = JSON.parse(fs.readFileSync(schemaPath, 'utf-8'));
      const types = generateTypes({
        schema,
        outputPath: options.output,
      });

      if (options.output) {
        const outputDir = path.dirname(options.output);
        if (!fs.existsSync(outputDir)) {
          fs.mkdirSync(outputDir, { recursive: true });
        }
        fs.writeFileSync(options.output, types);
        console.log(`✅ Type definitions written to ${options.output}`);
      } else {
        console.log(types);
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error('Error:', error.message);
      } else {
        console.error('An unknown error occurred');
      }
      process.exit(1);
    }
  });

program
  .command('init')
  .description('Initialize a new schema file')
  .option('-o, --output <path>', 'Output path for schema file', '.env.schema.json')
  .action(async (options) => {
    try {
      const defaultSchema = {
        NODE_ENV: ['development', 'production', 'test'],
        PORT: 'number',
        HOST: 'string',
        DEBUG: 'boolean',
      };

      const outputDir = path.dirname(options.output);
      if (!fs.existsSync(outputDir)) {
        fs.mkdirSync(outputDir, { recursive: true });
      }

      fs.writeFileSync(
        options.output,
        JSON.stringify(defaultSchema, null, 2) + '\n'
      );

      console.log(`✅ Schema file created at ${options.output}`);
      console.log('\nExample usage:');
      console.log('  $ env-schema-checker validate');
      console.log('  $ env-schema-checker gen-types -o types/env.d.ts');
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error('Error:', error.message);
      } else {
        console.error('An unknown error occurred');
      }
      process.exit(1);
    }
  });

program.parse(process.argv); 